module.exports = __webpack_public_path__ + "img/13-small.720cd2b5.png";